import { QuickAddSizeSelector } from 'libs/searchspring/components/QuickAddSizeSelector'

export function ResultQuickAddOverlay({ result }) {
  const variants = Array.isArray(result.variants) ? result.variants : []
  if (variants.length === 0) return null

  return (
    <div className="flex items-center justify-center w-full bg-brand-white/80 opacity-0 group-hover/card:opacity-100 transition-all">
      <QuickAddSizeSelector result={result} buttonClass="min-w-[28px] xl:min-w-[52px]" />
    </div>
  )
}
